import { useMemo, useState, useEffect, useRef} from "react";
import { FaSpinner } from "react-icons/fa";
import { useGroupChatContext } from "../../context/groupchatContext";
import RecentChat from "../groupChat/recentChat";
import MainPageDialog from "../../components/dialog";
import InfiniteScroll from 'react-infinite-scroll-component';
import React from "react";
import baseApiHelper from "../../services/baseApiHelper";

export default function ChatThreadListing({chatThreadsData, fetchMoreChats, isLoadingData, pagination}){

    const groupChatContext = useGroupChatContext();
    const {setIsOpeningSideBar, selectedLocations, chatFilter, isStopwatchActive,setIsStopwatchActive, setIsOpenStopWatchPopup,
        setElapsedTime, setSelectedMessageToReply, selectedMessageToReply,isPrintMessage,setIsPrintMessage,setSelectedMessages, loadThreadChats, isUrgentMessage, setIsUrgentMessage} = useMemo(() => ({
        setIsOpeningSideBar: groupChatContext.setIsOpeningSideBar,
        selectedLocations: groupChatContext.selectedLocations,
        chatFilter: groupChatContext.chatFilter,
        isStopwatchActive: groupChatContext.isStopwatchActive,
        setIsStopwatchActive: groupChatContext.setIsStopwatchActive,
        setIsOpenStopWatchPopup: groupChatContext.setIsOpenStopWatchPopup,
        setElapsedTime: groupChatContext.setElapsedTime,
        setSelectedMessageToReply: groupChatContext.setSelectedMessageToReply,
        selectedMessageToReply: groupChatContext.selectedMessageToReply,
        isPrintMessage: groupChatContext.isPrintMessage,
        setIsPrintMessage: groupChatContext.setIsPrintMessage,
        setSelectedMessages: groupChatContext.setSelectedMessages,
        loadThreadChats: groupChatContext.loadThreadChats,
        isUrgentMessage : groupChatContext.isUrgentMessage,
        setIsUrgentMessage: groupChatContext.setIsUrgentMessage,
    }));

    const [isTimerOn,setIsTimerOn]=useState(false);
    const [currentChat, setCurrentChat] = useState(null);
    const [shouldContinue, setShouldContinue] = useState(false);
    const recentChatScrollRef = useRef();

    const onClickChatThread = (chat) => {
        if(isUrgentMessage){
            setIsUrgentMessage(0);
        }
        if (selectedMessageToReply) {
            setSelectedMessageToReply(null);
        };
        if(isPrintMessage){
            setIsPrintMessage(false);
            setSelectedMessages([]);
        }
        if(isStopwatchActive){
            setIsTimerOn(true);
            setCurrentChat(chat); // required to store current chat
        }else{
            setIsOpeningSideBar(false);
            loadThreadChats({...chat, isChatThreadClicked: true});
        }
        baseApiHelper().invalidateTags(["UnreadMessageCount"]);
    }

    useEffect(()=>{
        scrollToTop();
    }, [selectedLocations, chatFilter])

    const scrollToTop = () => {
        if(recentChatScrollRef.current){
            recentChatScrollRef.current.scrollTo(0, 0);
        }
    }

    const footerlist=[
        {
            title: "No",
            action: () => {
                setIsTimerOn(false);
            },
            type: "cancel",
        },
        {
            title: "Yes",
            action: () => {
                setIsTimerOn(false);
                setIsStopwatchActive(false);
                setElapsedTime({ hours: 0, minutes: 0, seconds: 0 });
                setShouldContinue(true);
            },
            type: "edit",
        },
        {
            title: "LogTime",
            action: () => {
                setIsTimerOn(false);
                setIsOpenStopWatchPopup(true);

            },
            type: "save",
        },
    ]

    useEffect(() => {
        if (shouldContinue && currentChat) {
            setIsOpeningSideBar(false);
            loadThreadChats({...currentChat, isChatThreadClicked: true});
            setShouldContinue(false); // Reset the flag
        }
    }, [shouldContinue, currentChat]);

    useEffect(() => {
        if (selectedMessageToReply && selectedMessageToReply.length > 0 ) {
            setSelectedMessageToReply(null);
        }
    }, []);

    return(
        <div id="recentChatScrollableDiv" ref={recentChatScrollRef} className="flex h-content flex-col overflow-y-auto border-e border-gray-200 ring-1 ring-white/5 w-full">
            <InfiniteScroll
                dataLength={chatThreadsData?.data?.length || 0}
                next={fetchMoreChats}
                // style={{ display: 'flex' }}
                // inverse={true}
                // onScroll={handleScroll}
                hasMore={chatThreadsData?.meta?.pageCount > pagination.page}
                // loader={<h4 className='mt-6'>Loading...</h4>}
                scrollableTarget="recentChatScrollableDiv"
            >
                {chatThreadsData?.data?.map((chat, index)=>(
                        <RecentChat key={index} chat={chat} onClickChatThread={onClickChatThread} />
                    )
                )}
            </InfiniteScroll>

            {isLoadingData ? 
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto absolute inset-0 outline-none focus:outline-none before:absolute before:flex before:w-full before:h-full z-[999]">
                    <FaSpinner className="animate-spin text-green-300-500 ml-1" size={40} />
                </div>
                :
                (!chatThreadsData?.data?.length ? <div className='bg-gray  p-1 shadow-sm'>No Chat found</div> : null)
            }

            {isTimerOn?
                <MainPageDialog
                title="Alert!"
                footerList={footerlist}
                modalSize="md"
                maxHeight={true}
                onCancelHandler={() => setIsTimerOn(false)}
            >
                <div className="px-3 py-5  text-left text-lg text-gray-900">
                    <p>A timer for CCM activity is in progress. Do you want to discard and continue?</p>
                </div>
            </MainPageDialog>
            : null
            }
        </div>
    )
}